module.exports = fox._r("images/sprite.png", __webpack_public_path__ + "images/sprite.png");


//////////////////
// WEBPACK FOOTER
// ./images/sprite.png
// module id = 0
// module chunks = 5